<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <h3>Roles</h3>
      </div>
      <div class="col-md-4 offset-md-4">
        <p-button
          class="btn btn-success pull-right"
          @click="openModalAddRole"
          v-if="hasAddRolePermission()"
        >
          <i class="fas fa-user-shield"></i> Add a new Role
        </p-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 card">
        <div class="card-body row">
          <div class="col-2">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
              size="mini"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped" :data="tableData" border style="width: 100%">
              <el-table-column
                v-for="column in tableColumns"
                align="center"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
              <el-table-column
                :min-width="50"
                fixed="right"
                align="center"
                class-name="td-actions"
                label="Actions"
              >
                <template slot-scope="props">
                  <p-button
                    type="warning"
                    size="sm"
                    icon
                    @click="handleEdit(props.$index, props.row)"
                    v-if="hasEditRolePermission()"
                  >
                    <i class="fa fa-edit"></i>
                  </p-button>
                  <p-button
                    type="danger"
                    size="sm"
                    icon
                    @click="handleDelete(props.$index, props.row)"
                    v-if="hasDeleteRolePermission()"
                  >
                    <i class="fa fa-trash-alt"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              @input="inputChanged($event)"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- add new role modal -->
    <modal :show.sync="addRoleModal" footer-classes="justify-content-center" type="notice">
      <h5 slot="header" class="text-primary modal-title" v-if="!isEditing">Add Role</h5>
      <h5 slot="header" class="text-primary modal-title" v-else>Edit Role</h5>
      <template>
        <form>
          <div class="form-group">
            <fg-input
              label="Name"
              name="roleName"
              v-model="roleModel.roleName"
              :error="getError('roleName')"
              v-validate="'required'"
            ></fg-input>
          </div>
          <div class="form-group">
            <fg-input :error="getError('permissions')">
              <label for="inputStatus">Permissions</label>
              <div class="form-group">
                <input
                  type="checkbox"
                  id="SelectAll"
                  v-model="selectAllPermissionsBool"
                  @click="selectAllPermissions"
                />
                <label class="form-check-label" for="SelectAll">
                  <b>Select All</b>
                </label>
              </div>

              <div class="form-group" v-for="permission in permissions" v-bind:key="permission.id">
                <input
                  type="checkbox"
                  name="permissions"
                  v-model="roleModel.permission_ids"
                  :id="permission.id"
                  :value="permission.id"
                  v-validate="'required|min:1'"
                />
                <label class="form-check-label" :for="permission.id">{{ permission.name }}</label>
              </div>
            </fg-input>
          </div>
        </form>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="addRoleModal = false">Close</p-button>
        <p-button type="success" @click.native="addRoleValidation" v-if="!isEditing">Add role</p-button>
        <p-button type="success" @click.native="editRoleValidation" v-else>Save</p-button>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import users from "src/components/Dashboard/Views/Tables/users";
import HTTP from "src/util/http-common.js";
import Modal from "src/components/UIComponents/Modal.vue";
import swal from "sweetalert2";

export default {
  components: {
    Modal
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0
      },
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50
        },
        {
          prop: "roleName",
          label: "Role",
          minWidth: 120
        },
        {
          prop: "permissionDescriptions",
          label: "Permissions",
          minWidth: 150
        }
      ],
      tableData: [],
      addRoleModal: false,
      permissions: [],
      isEditing: false,
      roleModel: {
        roleName: null,
        permission_ids: []
      },
      selectAllPermissionsBool: false,
      generalPermissions: this.$store.getters["auth/generalPermissions"],
       user_permissions:null
    };
  },
      mounted() {
    var p = localStorage.getItem("permissions");
    var pr = JSON.parse(p);
    var permissions = pr.permissions;

    var canShowusers = permissions.includes("role.post");
    console.log(canShowusers, "canShowusers");

    if (canShowusers === false) {
      this.$router.push({ path: "/" });
    }
  },

  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    }
  },
  watch: {
    "pagination.perPage": function(newVal, oldVal) {
      this.pagination.currentPage = 1;
      this.setRoles();
    },
    addRoleModal: function(newVal, oldVal) {
      if (newVal == false) {
        this.$validator.pause();
        this.permissions = [];
        this.$validator.errors.clear();
        this.roleModel.roleName = null;
        this.roleModel.permission_ids = [];
        this.isEditing = false;
        this.selectAllPermissionsBool = false;
      }
    }
  },
  created() {
    this.setRoles();
  },
  methods: {
    handleLink(index, row) {
      this.$router.push({ path: `/bookings/${row.id}` });
    },
    inputChanged(pageNum) {
      this.setRoles();
    },
    async fetchRoles() {
      let params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.perPage
      };

      const response = await HTTP.get("api/v1/role/list", {
        params: params
      });
      const data = await response.data;
      return data;
    },
    setRoles() {
      this.tableData = [];
      let loader = this.$loading.show();
      this.fetchRoles()
        .then(data => {
          const results = data.results;
          for (var i = 0; i < results.length; i++) {
            var permission_str = [];
            for (var x = 0; x < results[i].permissions.length; x++) {
              permission_str.push(results[i].permissions[x].description);
            }
            this.tableData.push({
              id: results[i].id,
              roleName: results[i].role_name,
              permissionDescriptions: permission_str.join(", "),
              permission_dict: results[i].permissions
            });
          }
          this.pagination.total = data.total;
          // this.tableData = results;
          loader.hide();
        })
        .catch(err => {
          console.log(err);
          if ("response" in err) {
            this.$notify({
              group: "general",
              title: "Error fetching Role list",
              text: err.response.data.error,
              type: "error"
            });
          } else {
            this.$notify({
              group: "general",
              title: "Error fetching Role list",
              text: err,
              type: "error"
            });
          }

          loader.hide();
        });
    },
    openModalAddRole() {
      this.addRoleModal = true;
      this.setPermissions();
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async fetchPermissions() {
      let params = {
        permission_level: "all"
      };

      const response = await HTTP.get("api/v1/permission/list", {
        params: params
      });
      // const response = await HTTP.get("api/v1/permission/list", {
      //   params: params
      // });
      const data = await response.data;
      return data;
    },
    setPermissions() {
      let loader = this.$loading.show();
      this.fetchPermissions()
        .then(data => {
          const results = data.results;
          for (let row of data.results) {
            this.permissions.push({
              id: row.id,
              name: row.description
            });
          }
          loader.hide();
        })
        .catch(err => {
          this.$notify({
            group: "general",
            title: "Error fetching Permission list",
            text: err,
            type: "error"
          });
          loader.hide();
        });
    },
    async addRoleValidation() {
      this.$validator.resume();
      const isValid = await this.$validator.validateAll();
      console.log("isValid", isValid);
      if (isValid) {
        this.addRoleAPI();
      }
    },
    addRoleAPI() {
      var params = {
        name: this.roleModel.roleName,
        permission_id_list: this.roleModel.permission_ids
      };
      HTTP.post("api/v1/role/", params)
        .then(response => {
          this.addRoleModal = false;
          this.setRoles();
          swal({
            title: "Successfully added Role " + this.roleModel.roleName,
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success"
          });
        })
        .catch(err => {
          this.addRoleModal = false;
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              swal({
                title: "Bad Request",
                text: err.response.data.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          }
        });
    },
    handleEdit(index, row) {
      this.isEditing = true;
      this.addRoleModal = true;
      this.setPermissions();
      console.log(row);
      this.roleModel = Vue.util.extend({}, row);
      this.roleModel.permission_ids = [];
      for (let row of this.roleModel.permission_dict) {
        // console.log("role model", this.roleModel.permission_ids)
        this.roleModel.permission_ids.push(row.id);
      }
    },
    async editRoleValidation() {
      this.$validator.resume();
      const isValid = await this.$validator.validateAll();
      console.log("isValid", isValid);
      if (isValid) {
        this.editRoleAPI();
      }
    },
    editRoleAPI() {
      var params = {
        role_id: this.roleModel.id,
        name: this.roleModel.roleName,
        permission_id_list: this.roleModel.permission_ids
      };
      HTTP.put("api/v1/role/", params)
        .then(response => {
          this.addRoleModal = false;
          this.isEditing = false;
          this.setRoles();
          this.$store.dispatch("auth/retrieveUserPermissions");
          swal({
            title: "Successfully edited Role " + this.roleModel.roleName,
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success"
          });
          // location.reload()
        })
        .catch(err => {
          this.addRoleModal = false;
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              swal({
                title: "Bad Request",
                text: err.response.data.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          }
        });
    },
    selectAllPermissions() {
      if (this.selectAllPermissionsBool == false) {
        this.selectAllPermissionsBool = true;
        for (let row of this.permissions) {
          this.roleModel.permission_ids.push(row.id);
        }
      } else {
        this.selectAllPermissionsBool = false;
        this.roleModel.permission_ids = [];
      }
    },
    handleDelete(index, row) {
      this.deleteRoleAPI(row.id, row.roleName);
    },
    deleteRoleAPI(role_id, role_name) {
      var params = {
        role_id: role_id
      };
      HTTP.delete("api/v1/role/", { data: params })
        .then(response => {
          this.setRoles();
          swal({
            title: "Successfully deleted Role " + role_name,
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success"
          });
        })
        .catch(err => {
          this.addRoleModal = false;
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              swal({
                title: "Bad Request",
                text: err.response.data.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          }
        });
    },
    hasEditRolePermission() {
      if (this.user_permissions.includes("role.put")) {
        return true;
      }

      return false;
    },
    hasDeleteRolePermission() {
      if (this.user_permissions.includes("role.delete")) {
        return true;
      }

      return false;
    },
    hasAddRolePermission() {
      if (this.user_permissions.includes("role.post")) {
        return true;
      }

      return false;
    }
  },created(){
    this.user_permissions  = localStorage.getItem("permissions");
    this.setRoles()
  }
};
</script>
<style scoped lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
</style>
